import { Token } from "@siteimprove/alfa-css";
import { Iterable } from "@siteimprove/alfa-iterable";
import { Parser } from "@siteimprove/alfa-parser";
import { And } from "./and.js";
import { Not } from "./not.js";
import { Or } from "./or.js";
const { delimited, either, map, oneOrMore, option, pair, zeroOrMore } = Parser;
export var Condition;
(function (Condition) {
    function isCondition(value) {
        return And.isAnd(value) || Or.isOr(value) || Not.isNot(value);
    }
    Condition.isCondition = isCondition;
    /**
     * {@link https://drafts.csswg.org/mediaqueries-5/#typedef-media-in-parens}
     */
    function parseInParens(featureParser) {
        return either(delimited(Token.parseOpenParenthesis, delimited(option(Token.parseWhitespace), (input) => parse(featureParser)(input)), Token.parseCloseParenthesis), featureParser);
    }
    /**
     * {@link https://drafts.csswg.org/mediaqueries-5/#typedef-media-condition}
     *
     * @privateRemarks
     * We absolutely must defer evaluation of the parseInParens computation as lazily as
     * possible to avoid infinite recursion.
     */
    function parse(featureParser) {
        return either(Not.parse(parseInParens, featureParser), map(pair(parseInParens(featureParser), either(map(oneOrMore(And.parse(parseInParens, featureParser)), (queries) => [And.of, queries]), map(oneOrMore(Or.parse(parseInParens, featureParser)), (queries) => [Or.of, queries]))), ([left, [constructor, right]]) => Iterable.reduce(right, (left, right) => constructor(left, right), left)), parseInParens(featureParser));
    }
    Condition.parse = parse;
    /**
     * {@link https://drafts.csswg.org/mediaqueries-5/#typedef-media-condition-without-or}
     */
    function parseWithoutOr(featureParser) {
        return either(Not.parse(parseInParens, featureParser), map(pair(parseInParens(featureParser), zeroOrMore(And.parse(parseInParens, featureParser))), ([left, right]) => [left, ...right].reduce((left, right) => And.of(left, right))));
    }
    Condition.parseWithoutOr = parseWithoutOr;
})(Condition || (Condition = {}));
//# sourceMappingURL=condition.js.map